export default __webpack_public_path__ + "static/s.tremblay-1228590679685d4594a47fc96e7ffc74.png";